module.exports = __webpack_public_path__ + "img/u1980.a5c1d67b.png";